var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_DOISER_AREA_ID, SET_DOISER_COUNTRY_ID, SET_DOISER_TYPE } from "../actions/setDoiserStates";
var initialState = {
    areaId: null,
    countryId: null,
    type: null,
};
export function getDoiserStates(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_DOISER_AREA_ID:
            return __assign(__assign({}, state), { areaId: action.payload });
        case SET_DOISER_COUNTRY_ID:
            return __assign(__assign({}, state), { countryId: action.payload });
        case SET_DOISER_TYPE:
            return __assign(__assign({}, state), { type: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getDoiserStates.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_DOISER_AREA_ID, SET_DOISER_COUNTRY_ID, SET_DOISER_TYPE } from "../actions/setDoiserStates";
var initialState = {
    areaId: null,
    countryId: null,
    type: null,
};
export function getDoiserStates(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_DOISER_AREA_ID:
            return __assign(__assign({}, state), { areaId: action.payload });
        case SET_DOISER_COUNTRY_ID:
            return __assign(__assign({}, state), { countryId: action.payload });
        case SET_DOISER_TYPE:
            return __assign(__assign({}, state), { type: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getDoiserStates.js.map